import { connect } from 'react-redux';
import OrderBuyLimit from '../components/exchange/OrderBuyLimit';
import OrderSellLimit from '../components/exchange/OrderSellLimit';
import OrderStopLimit from '../components/exchange/OrderStopLimit';
import orderBookAction from '../redux/actions/orderbook';
import OrderMarketComponent from '../components/exchange/OrderMarketComponent';
import actionsOrderTrans from '../redux/actions/order_transaction';
import actions from '../redux/actions/order';

const mapStateToProps = (state) => ({
  user: state.user,
  coinSettings: state.setting.coinSettings,
  orderBook: state.orderBook,
});

const mapDispatchToProps = (dispatch) => ({
  onClickOrderBookBuy: (params) => {
    dispatch(orderBookAction.clickOrderBookBuy(params));
  },
  onClickOrderBookSell: (params) => {
    dispatch(orderBookAction.clickOrderBookSell(params));
  },
  onFetchIdOrderTrans: (params, callback) => {
    dispatch(actionsOrderTrans.fetchIdOrderTransactionsAction(params, callback));
  },
  onAddOrderAction: (params, callback) => {
    dispatch(actions.addOrderAction(params, callback));
  },
});

export const OrderBuyLimitContainer = connect(mapStateToProps, mapDispatchToProps)(OrderBuyLimit);
export const OrderSellLimitContainer = connect(mapStateToProps, mapDispatchToProps)(OrderSellLimit);
export const OrderStopLimitContainer = connect(mapStateToProps, mapDispatchToProps)(OrderStopLimit);
export const OrderMarketContainer = connect(mapStateToProps, mapDispatchToProps)(OrderMarketComponent);
